// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconArrowRight = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M54.8275 30.6366C54.028 29.7785 37.1239 11.6337 36.2615 10.7082C35.3992 9.78264 34.2786 9.76286 33.384 10.6574C32.4895 11.5518 31.5519 12.4894 30.6573 13.384C29.7629 14.2785 29.7827 15.3991 30.7083 16.2614C31.2927 16.8061 38.7802 23.7817 44.2218 28.8512C34.8046 28.6009 13.0613 28.0232 12.0691 28.0007C10.801 27.9718 10 28.7548 10 30.0234V33.9765C10 35.245 10.801 36.028 12.0691 35.9992C13.0613 35.9766 34.8047 35.399 44.2219 35.1486C38.7803 40.2182 31.2927 47.1939 30.7082 47.7384C29.7827 48.6007 29.7628 49.7214 30.6573 50.6159L33.384 53.3426C34.2785 54.2371 35.3992 54.2172 36.2615 53.2917C37.1239 52.3661 54.028 34.2214 54.8275 33.3632C55.627 32.5052 55.627 31.4947 54.8275 30.6366Z" />
    </svg>
  );
};
